/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CreatePriceMode = {
    Create: 'Create',
    Approve: 'Approve'
} as const;
export type CreatePriceMode = typeof CreatePriceMode[keyof typeof CreatePriceMode];


export function instanceOfCreatePriceMode(value: any): boolean {
    for (const key in CreatePriceMode) {
        if (Object.prototype.hasOwnProperty.call(CreatePriceMode, key)) {
            if (CreatePriceMode[key as keyof typeof CreatePriceMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CreatePriceModeFromJSON(json: any): CreatePriceMode {
    return CreatePriceModeFromJSONTyped(json, false);
}

export function CreatePriceModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePriceMode {
    return json as CreatePriceMode;
}

export function CreatePriceModeToJSON(value?: CreatePriceMode | null): any {
    return value as any;
}

export function CreatePriceModeToJSONTyped(value: any, ignoreDiscriminator: boolean): CreatePriceMode {
    return value as CreatePriceMode;
}

